module.exports = __webpack_public_path__ + "static/media/circle.444f450c.svg";